export const NAV = {
  dashboard: 'nav-dashboard',
  myWhatsapp: 'nav-my-whatsapp',
  contacts: 'nav-contacts',
  feedbacks: 'nav-feedbacks',
  supervisor: 'nav-supervisor',
};

export const HEADER = {
  connectionIndicator: 'header-connection-status-indicator',
  logoutButton: 'logout-button',
};

export const WA = {
  qrContainer: 'qr-code-canvas-container',
  statusBadge: 'qr-status-badge',
  disconnectButton: 'whatsapp-disconnect-button',
  reconnectButton: 'whatsapp-reconnect-button',
  startButton: 'whatsapp-start-button',
  sendInput: 'chat-message-input',
  sendPhone: 'chat-phone-input',
  sendButton: 'chat-send-button',
};

export const SUP = {
  userRow: 'supervisor-user-row',
  drilldownButton: 'supervisor-drilldown-button',
  feedbackItem: 'feedback-item-card',
};
